import { CannotLicensePC } from "./CannotLicensePC";

export function CannotLicensePCContainer() {
  return <CannotLicensePC data-qatag="CannotLicensePCWrapper" />;
}
